import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import { TableRow } from '../TableRow';
import { TableCell } from '../TableCell';

export interface TableLoadingStateProps {
  columnLength: number;
  rowLength: number;
}

const generateSkeletonArr = (length: number) => Array.from(Array(length).keys());

export const TableLoadingState: React.FunctionComponent<TableLoadingStateProps> = ({ columnLength, rowLength }) => {
  const columnSkeletonArr = generateSkeletonArr(columnLength);
  const rowSkeletonArr = generateSkeletonArr(rowLength);

  return (
    <>
      {/* TableLoadingState */}
      {rowSkeletonArr.map((row) => (
        <TableRow key={`row-${row}`}>
          {columnSkeletonArr.map((cell) => (
            <TableCell key={`cell-${cell}`}>
              <Skeleton width={120} height={40} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};
